import { useEffect, useState } from '@wordpress/element';
import styles from "./InputGroup.module.css";

const InputGroup = ({
  label,
  id,
  type = "text",
  placeholder = "",
  value: defaultValue = "",
  onChange,
  info = "",
  min,
  max,
  step,
}) => {
  const [value, setValue] = useState(defaultValue);

  // Update local state when prop value changes from parent
  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  const handleChange = (e) => {
    let newValue = e.target.value;
    
    // For number type, validate min/max
    if (type === "number" && min !== undefined && max !== undefined) {
      let numValue = parseInt(newValue, 10);
      if (!isNaN(numValue)) {
        if (numValue < parseInt(min, 10)) numValue = parseInt(min, 10);
        if (numValue > parseInt(max, 10)) numValue = parseInt(max, 10);
        newValue = numValue;
      }
    }
    
    setValue(newValue);
    if (onChange) onChange(newValue);
  };

  return (
    <div className={styles["hvnly_settings_api__form-group"]}>
      {label && (
        <label
          className={styles["hvnly_settings_api__form-label"]}
          htmlFor={id}
        >
          {label}
        </label>
      )}
      <input
        type={type}
        id={id}
        className={styles["hvnly_settings_api__form-control"]}
        value={value}
        placeholder={placeholder}
        onChange={handleChange}
        min={min}
        max={max}
        step={step}
      />
      {info && (
        <small className={styles["hvnly_settings_api__form-inputgroup-info"]}>
          {info}
        </small>
      )}
    </div>
  );
};

export default InputGroup;